<template>
  <div class="content">
    <div class="banner">
      <img :src="getBanner" alt="banner" />
    </div>
    <PageHeader v-if="!isHome" title="返回" @back="back" />
    <div class="topTitle">
      <h2>{{ getConfig.systemName || "激活系统" }}</h2>
      <p>{{ getConfig.systemNameEn || "Activation System" }}</p>
    </div>
    <router-view />
    <div class="footer"><img :src="getFooter" alt="" /></div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PageHeader from "@/components/PageHeader.vue";
import DefaultBanner from "@/assets/img/banner.png";
import DefaultFooter from "@/assets/img/footer.png";
export default {
  components: {
    PageHeader,
  },
  data() {
    return {
      isHome: true,
    };
  },
  computed: {
    ...mapGetters("activationStore", ["getConfig"]),
    getBanner() {
      return this.getConfig.banner || DefaultBanner;
    },
    getFooter() {
      return this.getConfig.footer || DefaultFooter;
    },
  },
  methods: {
    back() {
      if (!this.isHome) {
        localStorage.clear();
        this.$router.back();
      }
    },
  },
};
</script>
